import React, { Component } from 'react'
import moment from 'moment'
import {
  Form,
  Input,
  Select,
  Spin,
  Button,
  message,
  notification,
  Modal,
  Tabs,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import { __ } from '@wordpress/i18n'
import { GoogleLogin } from 'react-google-login'
import axios, { Cancel, CancelToken } from 'axios'

import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import { genFormItemAtrribute } from 'libs/FormHelper'

const FB = window.FB
const gapi = window.gapi
const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class UserPoint extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    tableData: [],
    visible: false,
    confirmLoading: false,
    pw: null,
    openid: null,
    sp_code: null,
    isLoading: true,
  }

  componentDidMount() {
    AppHelper.updateConfig()

    this.setState({ isFetchData: true, info: this.props.user }, () => {
      this.reloadTab()
    })

    //AppHelper.getAccountGroup(() => {

    //  this.setState({ isFetchData: false })

    //this.fillData(this.props.user)
    //});

    this.loadAccountGroup(connect)

    this.setState({ info: this.props.user })
    //this.loadData();

    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  loadAccountGroup = (callback = () => {}) => {
    const query = AppHelper.getHashParamaters()

    this.setState({ isFetchData: true })

    whttp.sharedGet(
      API_HOST + `/api/account/getAccountGroup`,
      {},
      (state, res) => {
        this.setState({ isFetchData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res

        console.log(code, reason, data, res)

        if (state === false || code !== 200) {
          message.warning(reason)
          //this.props.history.replace("/brands")
          return
        }

        console.log('getAccountGroup', data)
        this.setState({ tableData: data }, () => {
          if (_.isFunction(callback)) callback()
        })
      }
    )
  }

  loadData = (opt = { page: 1, page_size: 10 }) => {
    const { table_query } = this.state
    const { page, page_size } = opt

    this.setState({ isLoadingData: true })
    whttp.post(
      API_HOST + '/api/account/eInvoiceList',
      {
        start_dt: moment()
          .subtract(1, 'months')
          .format('YYYY-MM-DD'),
        end_dt: moment().format('YYYY-MM-DD'),
      },
      (state, res) => {
        this.setState({ isLoadingData: false })
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return this.setState({ message: '發生錯誤' })
        }

        if (code !== 200) {
          return this.setState({ message: reason })
        }

        this.setState({ tableData: data })
      }
    )
  }
  fillData = (data = {}) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log(data)
    this.formRef.current.setFieldsValue(data)
    this.setState({ isLoading: false }, () => {
      this.reloadTab()
    })
  }

  submitData = (info = {}) => {
    info.spcode = 'C4'
    console.log('submitData', info)
    this.setState({ isSubmitData: true, messages: {} })

    whttp.post(API_HOST + `/api/account/accountGroup`, info, (state, res) => {
      console.log(state, res)

      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        notification['error']({
          message: '連結失敗',
          description: reason,
        })

        return this.setState({ messages: data.messages || {} })
      }

      message.success('連結成功')
    })
  }
  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)
  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { info, tableData = [] } = this.state
    const account = _.get(this, 'state.tableData.accounts', [])
    const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL')
    const test_account = [
      {
        login: 'kktry.iie98g@g2.nctu.edu.tw',
        sp_code: 'C4',
      },

      /*{
        "openid": "1234",
        "sp_code": "GG"
    },
    {
        "openid": "123",
        "sp_code": "LI"
    },*/
      {
        openid: '123',
        sp_code: 'FB',
      },
    ]
    this.refreshPicker()
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('第三方登入設定', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('第三方登入設定', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.cn_name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
            </section>
          </div>
          <section class='pt-0'>
            <div class='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul class='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/payment`}
                    >
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
              {Local == 'en_US' && (
                <ul class='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile-en`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/payment-en`}>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point-en`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice-en`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div id='container' class='container'>
              <p className='h6 text-navy fw-700 mb-2'>
                {__(
                  '第三方驗證登入更快速，您可以在此將您的帳號與其他社群登入帳號做連結，設定完成後即可以用Facebook/Google/LINE帳號登入會員帳號囉。',
                )}
              </p>
              <div className='justify-content-center'>
                {!tableData.gid && (
                  <Spin id='spin'>
                    <div
                      class='row justify-content-center'
                      style={{ minHeight: 200 }}
                    />
                  </Spin>
                )}
              </div>
              {tableData.gid && (
                <div class='row no-gutters mx-n3 mb-4'>
                  <div class='col-md-6 col-lg-3 px-3 mb-4'>
                    <div class='card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'>
                      {_.find(account, function(o) {
                        return o.sp_code == 'C4'
                      }) &&
                        _.filter(
                          account,
                          (item) => item.sp_code == 'C4',
                        ).map((item) => (
                          <div class='card-body'>
                            <div class='mb-5'>
                              <div class='icon-circle-block mx-auto mb-3'>
                                <img
                                  src={`${
                                    VC_CONFIG.INDEX_URL
                                  }/wp-content/themes/cec/assets/img/logo/logo-icon.svg`}
                                  alt='帳號'
                                />
                              </div>
                              <h5 class='h5 text-navy text-center mb-2'>
                                {__('帳號', 'cec-plugin-stores')}
                              </h5>
                              <p
                                id='C4-connected'
                                class='note text-font text-center mb-0'>
                                {__('已綁定', 'cec-plugin-stores')}
                              </p>
                            </div>
                            <p class='h6 text-primary text-center btn btn-block rounded-pill py-4'>
                              {item.login}
                            </p>
                            <a
                              class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                              role='button'
                              href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                              {__('修改密碼', 'cec-plugin-stores')}
                            </a>
                          </div>
                        ))}
                      {!_.find(account, function(o) {
                        return o.sp_code == 'C4'
                      }) && (
                        <div class='card-body'>
                          <div class='mb-5'>
                            <div class='icon-circle-block mx-auto mb-3'>
                              <img
                                src={`${
                                  VC_CONFIG.INDEX_URL
                                }/wp-content/themes/cec/assets/img/logo/logo-icon.svg`}
                                alt='帳號'
                              />
                            </div>
                            <h5 class='h5 text-navy text-center mb-2'>
                              {__('帳號', 'cec-plugin-stores')}
                            </h5>
                            <p class='note text-font text-center mb-0'>
                              {__('尚未綁定', 'cec-plugin-stores')}
                            </p>
                          </div>
                          <a
                            id='C4_connect'
                            class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                            role='button'
                            href='#'
                            onClick={(e) => e.preventDefault()}>
                            {__('進行連結', 'cec-plugin-stores')}
                          </a>
                          <Form
                            noStyle
                            ref={this.formRef}
                            id='C4_Form'
                            name='basic'
                            style={{ display: 'none' }}
                            layout='vertical'
                            onFinish={(values) => this.submitData(values)}
                            //onValuesChange={(changedFields, allFields) => {
                            //  console.log('onValuesChange:', changedFields, allFields)
                            //}}
                          >
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: __(
                                    '請輸入您的帳號',
                                    'cec-plugin-stores',
                                  ),
                                },
                              ]}
                              {...genFormItemAtrribute('login')}>
                              <Input
                                placeholder={__(
                                  '請輸入您的帳號',
                                  'cec-plugin-stores',
                                )}
                                className='form-control'
                              />
                            </Form.Item>
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: __(
                                    '請輸入密碼',
                                    'cec-plugin-stores',
                                  ),
                                },
                              ]}
                              {...genFormItemAtrribute('pw')}>
                              <Input.Password
                                placeholder={__(
                                  '請輸入密碼',
                                  'cec-plugin-stores',
                                )}
                                className='form-control'
                              />
                            </Form.Item>
                            <a
                              className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                              role='button'
                              href='#'
                              onClick={(e) => {
                                e.preventDefault()
                                this.formRef.current.submit()
                              }}>
                              {__('確認', 'cec-plugin-stores')}
                            </a>
                          </Form>
                        </div>
                      )}
                    </div>
                  </div>
                  <div class='col-md-6 col-lg-3 px-3 mb-4'>
                    <div class='card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'>
                      {_.find(account, function(o) {
                        return o.sp_code == 'FB'
                      }) &&
                        _.filter(
                          account,
                          (item) => item.sp_code == 'FB',
                        ).map((item) => (
                          <div class='card-body'>
                            <div class='mb-5'>
                              <div class='icon-circle-block mx-auto mb-3'>
                                <i class='icon-facebook' />
                              </div>
                              <h5 class='h5 text-navy text-center mb-2'>
                                {__('Facebook 登入', 'cec-plugin-stores')}
                              </h5>
                              <p
                                id='FB-connected'
                                class='note text-font text-center mb-0'>
                                {__('已綁定', 'cec-plugin-stores')}
                              </p>
                            </div>
                            <p class='h6 text-primary text-center btn btn-block rounded-pill py-4'>
                              {item.openid}
                            </p>
                          </div>
                        ))}
                      {!_.find(account, function(o) {
                        return o.sp_code == 'FB'
                      }) && (
                        <div class='card-body'>
                          <div class='mb-5'>
                            <div class='icon-circle-block mx-auto mb-3'>
                              <i class='icon-facebook' />
                            </div>
                            <h5 class='h5 text-navy text-center mb-2'>
                              {__('Facebook 登入', 'cec-plugin-stores')}
                            </h5>
                            <p class='note text-font text-center mb-0'>
                              {__('尚未綁定', 'cec-plugin-stores')}
                            </p>
                          </div>
                          <a
                            id='FB_connect'
                            class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                            role='button'
                            href='#'
                            onClick={(e) => e.preventDefault()}>
                            {__('進行連結', 'cec-plugin-stores')}
                          </a>
                          <Form
                            noStyle
                            id='FB_Form'
                            name='basic'
                            style={{ display: 'none' }}
                            layout='vertical'
                            //onFinish={values => console.log(values.FBpw) }
                          >
                            {__(
                              '因連結外部帳號，請您再次輸入您的密碼!',
                              'cec-plugin-stores',
                            )}
                            <Form.Item
                              id='FBpwForm'
                              rules={[
                                {
                                  required: true,
                                  message: __(
                                    '請輸入密碼',
                                    'cec-plugin-stores',
                                  ),
                                },
                              ]}
                              {...genFormItemAtrribute('FBpw')}>
                              <Input.Password
                                name='FBpwd'
                                placeholder={__(
                                  '請輸入密碼',
                                  'cec-plugin-stores',
                                )}
                                className='form-control'
                              />
                            </Form.Item>
                            <Form.Item>
                              <Button
                                id='FBgetBind'
                                type='primary'
                                htmlType='submit'
                                class='h6 btn btn-block btn-outline-primary rounded-pill py-4'>
                                {__('確認', 'cec-plugin-stores')}
                              </Button>
                            </Form.Item>
                          </Form>
                        </div>
                      )}
                    </div>
                  </div>

                  <div class='col-md-6 col-lg-3 px-3 mb-4'>
                    <div class='card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'>
                      {_.find(account, function(o) {
                        return o.sp_code == 'GG'
                      }) &&
                        _.filter(
                          account,
                          (item) => item.sp_code == 'GG',
                        ).map((item) => (
                          <div class='card-body'>
                            <div class='mb-5'>
                              <div class='icon-circle-block mx-auto mb-3'>
                                <i class='fab fa-google-plus-g' />
                              </div>
                              <h5 class='h5 text-navy text-center mb-2'>
                                {__('Google+ 登入', 'cec-plugin-stores')}
                              </h5>
                              <p
                                id='GG-connected'
                                class='note text-font text-center mb-0'>
                                {__('已綁定', 'cec-plugin-stores')}
                              </p>
                            </div>
                            <p class='h6 text-primary text-center btn btn-block rounded-pill py-4'>
                              {item.openid}
                            </p>
                          </div>
                        ))}
                      {!_.find(account, function(o) {
                        return o.sp_code == 'GG'
                      }) && (
                        <div class='card-body'>
                          <div class='mb-5'>
                            <div class='icon-circle-block mx-auto mb-3'>
                              <i class='fab fa-google-plus-g' />
                            </div>
                            <h5 class='h5 text-navy text-center mb-2'>
                              {__('Google+ 登入', 'cec-plugin-stores')}
                            </h5>
                            <p class='note text-font text-center mb-0'>
                              {__('尚未綁定', 'cec-plugin-stores')}
                            </p>
                          </div>
                          {
                            // <a id='GG_connect' class="h6 btn btn-block btn-outline-primary rounded-pill py-4" role="button" href="javascript:void(0)">{__('進行連結','cec-plugin-stores')}</a>
                          }
                          <GoogleLogin
                            clientId='260812646328-b62s7lbkc6s51qve5kd7f0krf3pjf4rb.apps.googleusercontent.com'
                            render={(renderProps) => (
                              <button
                                id='GG_connect'
                                disabled={renderProps.disabled}
                                class='h6 btn btn-block btn-outline-primary rounded-pill py-4'>
                                {__('進行連結', 'cec-plugin-stores')}
                              </button>
                            )}
                            buttonText='Login'
                            onSuccess={(response) => {
                              console.log(response)
                            }}
                            onFailure={(response) => {
                              console.log(response)
                            }}
                            cookiePolicy={'single_host_origin'}
                          />
                          <Form
                            noStyle
                            id='GG_Form'
                            name='basic'
                            style={{ display: 'none' }}
                            layout='vertical'>
                            {__(
                              '因連結外部帳號，請您再次輸入您的密碼!',
                              'cec-plugin-stores',
                            )}
                            <Form.Item
                              id='GGpwForm'
                              rules={[
                                {
                                  required: true,
                                  message: __(
                                    '請輸入密碼',
                                    'cec-plugin-stores',
                                  ),
                                },
                              ]}
                              {...genFormItemAtrribute('GGpw')}>
                              <Input.Password
                                name='GGpwd'
                                placeholder={__(
                                  '請輸入密碼',
                                  'cec-plugin-stores',
                                )}
                                className='form-control'
                              />
                            </Form.Item>
                            <Form.Item>
                              <Button
                                id='GGgetBind'
                                type='primary'
                                htmlType='submit'
                                class='h6 btn btn-block btn-outline-primary rounded-pill py-4'>
                                {__('確認', 'cec-plugin-stores')}
                              </Button>
                            </Form.Item>
                          </Form>
                        </div>
                      )}
                    </div>
                  </div>
                  <div class='col-md-6 col-lg-3 px-3 mb-4'>
                    <div class='card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'>
                      {_.find(account, function(o) {
                        return o.sp_code == 'LI'
                      }) &&
                        _.filter(
                          account,
                          (item) => item.sp_code == 'LI',
                        ).map((item) => (
                          <div class='card-body'>
                            <div class='mb-5'>
                              <div class='icon-circle-block mx-auto mb-3'>
                                <i class='icon-line' />
                              </div>
                              <h5 class='h5 text-navy text-center mb-2'>
                                {__('LINE 登入', 'cec-plugin-stores')}
                              </h5>
                              <p class='note text-font text-center mb-0'>
                                {__('已綁定', 'cec-plugin-stores')}
                              </p>
                            </div>
                            <p class='h6 text-primary text-center btn btn-block rounded-pill py-4'>
                              {item.openid}
                            </p>
                          </div>
                        ))}
                      {!_.find(account, function(o) {
                        return o.sp_code == 'LI'
                      }) && (
                        <div class='card-body'>
                          <div class='mb-5'>
                            <div class='icon-circle-block mx-auto mb-3'>
                              <i class='icon-line' />
                            </div>
                            <h5 class='h5 text-navy text-center mb-2'>
                              {__('LINE 登入', 'cec-plugin-stores')}
                            </h5>
                            <p class='note text-font text-center mb-0'>
                              {__('尚未綁定', 'cec-plugin-stores')}
                            </p>
                          </div>
                          <a
                            id='LI_connect'
                            class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                            role='button'
                            href='#'
                            onClick={(e) => e.preventDefault()}>
                            {__('進行連結', 'cec-plugin-stores')}
                          </a>
                          <Form
                            noStyle
                            id='LI_Form'
                            name='basic'
                            style={{ display: 'none' }}
                            layout='vertical'
                            //onFinish={values => console.log(values.LIpw) }
                          >
                            {__(
                              '因連結外部帳號，請您再次輸入您的密碼!',
                              'cec-plugin-stores',
                            )}
                            <Form.Item
                              id='LIpwForm'
                              rules={[
                                {
                                  required: true,
                                  message: __(
                                    '請輸入密碼',
                                    'cec-plugin-stores',
                                  ),
                                },
                              ]}
                              {...genFormItemAtrribute('LIpw')}>
                              <Input.Password
                                name='LIpwd'
                                placeholder={__(
                                  '請輸入密碼',
                                  'cec-plugin-stores',
                                )}
                                className='form-control'
                              />
                            </Form.Item>
                            <Form.Item>
                              <Button
                                id='LIgetBind'
                                type='primary'
                                htmlType='submit'
                                class='h6 btn btn-block btn-outline-primary rounded-pill py-4'>
                                {__('確認', 'cec-plugin-stores')}
                              </Button>
                            </Form.Item>
                          </Form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div class='row no-gutters mx-n3 mb-4'>
                <div class='col-lg-3 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 class='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div class='col-lg-9 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '客服中心：市話 0809-001-365 / 手機(02)8006-9999 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserConnectEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }

  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-users-connect-editor'>
        <h2>會員關聯帳號模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}

const connect = () => {
  console.log('Container-Bind')
  var getUrlString = window.location.href
  var url = new URL(getUrlString)
  if (url.searchParams.get('code') && url.searchParams.get('state') == 'LI') {
    const data = {
      grant_typ: 'authorization_code',
      code: url.searchParams.get('code'),
      //redirect_uri: 'http://localhost:8080/cec/connect',
      //client_id: '1654222822',
      //client_secret: '0bc2d82037c9794636215114c0263033'
      redirect_uri: 'https://cec.syscom.tw/connect',
      client_id: '1630186793',
      client_secret: 'e08bc2fa98afdab36927fcf9d3898c05',
    }
    var postData =
      'grant_type=' +
      data.grant_typ +
      '&code=' +
      data.code +
      '&redirect_uri=' +
      data.redirect_uri +
      '&client_id=' +
      data.client_id +
      '&client_secret=' +
      data.client_secret
    console.log('LINE-qs.data', postData)
    const config = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
    axios
      .post('https://api.line.me/oauth2/v2.1/token', postData, config)
      .then((result) => {
        var tmpIdToken = result.data.id_token
        console.log('LINE-result', tmpIdToken)
        var tmpSub = parseJwt(tmpIdToken).sub
        console.log('LINE-result111111', tmpSub)
        bindAccount('LI', tmpSub)
      })
      .catch((err) => {
        console.log('LINE-ERROR', err)
      })
    // 轉換編碼
    function parseJwt(token) {
      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace('-', '+').replace('_', '/')
      return JSON.parse(window.atob(base64))
    }
  }

  //bindAccount
  function bindAccount(spcode, openid) {
    console.log('bindAccount', spcode, openid)
    var C4Account = $('#C4-connected').html()
    var tmppwd = null
    console.log('bindAccount-C4Account', C4Account)
    if (C4Account) {
      console.log('bindAccount-C4AccountC4Account')
      $('#' + spcode + '_connect').attr('style', 'display:none')
      $('#' + spcode + '_Form').show()
      $('#' + spcode + 'getBind').click(function() {
        if (spcode == 'FB') {
          tmppwd = $('#' + spcode + '_Form')
            .find('input[name="FBpwd"]')
            .val()
        } else if (spcode == 'GG') {
          tmppwd = $('#' + spcode + '_Form')
            .find('input[name="GGpwd"]')
            .val()
        } else if (spcode == 'LI') {
          tmppwd = $('#' + spcode + '_Form')
            .find('input[name="LIpwd"]')
            .val()
        }
        //結果
        console.log('bindAccount', spcode, openid, tmppwd)
        console.log('bindAccount1111111111111111111', $('#C4-connected').html())
        whttp.post(
          API_HOST + `/api/account/accountGroup`,
          { spcode: spcode, openid: openid, pw: tmppwd },
          (state, res) => {
            console.log(state, res)
            const {
              code = 100,
              reason = __('發生錯誤', 'cec-plugin-stores'),
              data = {},
            } = res
            if (state === false) {
              return message.error(__('發生錯誤', 'cec-plugin-stores'))
            }
            if (code !== 200) {
              notification['error']({
                message: __('連結失敗', 'cec-plugin-stores'),
                description: reason,
              })
              return message.error(__('連結失敗', 'cec-plugin-stores'))
            }
            Modal.success({
              title: 'Good job！',
              content: __(
                '恭喜您成功連結帳號，之後您亦可用已連結的帳號登入。',
                'cec-plugin-stores'
              ),
            })
            window.location.href = VC_CONFIG.INDEX_URL + '/connect'
          }
        )
      })
    } else {
      console.log('bindAccount-else')
      whttp.post(
        API_HOST + `/api/account/accountGroup`,
        { spcode: spcode, openid: openid },
        (state, res) => {
          console.log(state, res)
          const {
            code = 100,
            reason = __('發生錯誤', 'cec-plugin-stores'),
            data = {},
          } = res

          if (state === false) {
            return message.error(__('發生錯誤', 'cec-plugin-stores'))
          }

          if (code !== 200) {
            notification['error']({
              message: __('連結失敗', 'cec-plugin-stores'),
              description: reason,
            })
            return message.error(__('連結失敗', 'cec-plugin-stores'))
          }
          Modal.success({
            title: 'Good job！',
            content: __(
              '恭喜您成功連結帳號，之後您亦可用已連結的帳號登入。',
              'cec-plugin-stores'
            ),
          })
          window.location.href = VC_CONFIG.INDEX_URL + '/connect'
        }
      )
    }
  }

  //C4
  $(document).on('click', '#C4_connect', function() {
    console.log('jQuery', $(this))
    $(this).attr('style', 'display:none')
    console.log('jQuery', $('#C4_Form'))
    $('#C4_Form').show()
  })

  //Facebook
  ;(function(d, s, id) {
    console.log('Facebookfunctionfunction')
    var js,
      fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) {
      return
    }
    js = d.createElement(s)
    js.id = id
    js.src = 'https://connect.facebook.net/zh_TW/sdk.js'

    js.integrity = "sha384-tGX9ELjlGPfAjLclS6ecSCLOYvJv8fPBjbWdPdsWANwE4VxBwBPmhPqBnqFsuT0Y";           
    js.crossOrigin = 'anonymous';

    js.onerror = function (e) {
      console.error('FB SDK 載入失敗（可能 SRI/CORS）', e);
    };

    fjs.parentNode.insertBefore(js, fjs)
  })(document, 'script', 'facebook-jssdk')

  $(document).on('click', '#FB_connect', function() {
    console.log('jQuery-FB_click')
    window.fbAsyncInit = function() {
      console.log('fbAsyncInit')
      FB.init({
        appId: '826182204185577',
        cookie: true,
        xfbml: true,
        version: 'v7.0',
      })
      FB.AppEvents.logPageView()
    }
    FB.init({
      appId: '826182204185577',
      cookie: true,
      xfbml: true,
      version: 'v7.0',
    })
    FB.AppEvents.logPageView()
    FB.logout(function(response) {
      // Person is now logged out
      console.log('jQuery-FB_logout111', response)
    })
    FB.login(function(response) {
      //檢查臉書登入狀態
      console.log('jQuery-FB_55555')
      //如果已經有授權過應用程式
      if (response.status === 'connected') {
        console.log('jQuery-FB11', response)
        var userId = response.authResponse.userID
        console.log('jQuery-FB-userId', userId)
        bindAccount('FB', userId)
        //這邊就可以判斷取得資料跟網站使用者資料是否一致
      } else {
        //沒授權過應用程式
        //呼叫FB.login()請求使用者授權
        FB.login(function(response) {
          if (response.status === 'connected') {
            var userId = response.authResponse.userID
            bindAccount('FB', userId)
          } else {
            Modal.error({
              title: 'Facebook尚未登入成功！',
            })
          }
        })
      }
      FB.logout(function(response) {
        // Person is now logged out
        console.log('jQuery-FB_logout2222', response)
      })
    })
  })

  //Google
  $(document).on('click', '#GG_connect', function() {
    console.log('jQuery-GG_click')
    const script = document.createElement('script')
    script.src = 'https://apis.google.com/js/api.js'
    document.body.appendChild(script)
    let Google_appId =
      '260812646328-b62s7lbkc6s51qve5kd7f0krf3pjf4rb.apps.googleusercontent.com'
    script.onload = () => {
      console.log('jQuery-GG_click22')
      gapi.load('client:auth2', {
        callback: function() {
          // Initialize client & auth libraries
          console.log('jQuery-GG_click33')
          gapi.client
            .init({
              clientId: Google_appId,
              //scope: 'https://www.googleapis.com/auth/userinfo.profile'
            })
            .then(
              function(success) {
                // Google Libraries are initialized successfully
                // You can now make API calls
                console.log('Google Libraries are initialized successfully')
                gapi.auth2
                  .getAuthInstance()
                  .signIn()
                  .then(
                    function(success) {
                      // Login API call is successful
                      var profile = success.getId()
                      console.log('GG', success.Ca)
                      console.log('GG', success)
                      bindAccount('GG', profile)
                    },
                    function(error) {
                      // Error occurred
                      // console.log(error) to find the reason
                      console.log(error)
                    }
                  )
              },
              function(error) {
                // Error occurred
                console.log(error) // to find the reason
              }
            )
        },
        onerror: function() {
          // Failed to load libraries
          console.log('Failed to load libraries')
        },
      })
    }
  })

  //LINE
  $(document).on('click', '#LI_connect', function() {
    var URL = 'https://access.line.me/oauth2/v2.1/authorize?'
    URL += 'response_type=code'
    //URL += '&client_id=1654222822';
    URL += '&client_id=1630186793'
    //URL += '&redirect_uri=http://localhost:8080/cec/connect';
    URL += '&redirect_uri=https://cec.syscom.tw/connect'
    URL += '&state=LI'
    URL += '&scope=openid%20profile'
    window.location.href = URL
  })
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-connect.js